
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Client } from "@/types/client";

export const useClients = () => {
  return useQuery({
    queryKey: ["clients"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("clients")
        .select(`
          *,
          companies:company_id (
            id,
            name_ar
          ),
          creator:created_by (
            id,
            name
          ),
          client_assignments (
            id,
            role,
            employee_id,
            employees (
              id,
              name
            )
          )
        `)
        .order("created_at", { ascending: false });
      
      if (error) {
        console.error("Error fetching clients:", error);
        throw error;
      }
      
      // Get company names for clients with company_id
      let transformedData = data || [];
      
      if (data && data.length > 0) {
        // Get unique company IDs
        const companyIds = [...new Set(data
          .filter(client => client.company_id)
          .map(client => client.company_id)
        )];
        
        if (companyIds.length > 0) {
          try {
            const { data: companies } = await supabase
              .from("companies")
              .select("id, name_ar")
              .in("id", companyIds);
            
            const companyMap = new Map(companies?.map(c => [c.id, c.name_ar]) || []);
            
            transformedData = data.map(client => ({
              ...client,
              company: client.company_id ? companyMap.get(client.company_id) || client.company : client.company,
              // إضافة بيانات الموظف للتوافق مع النظام القديم
              employees: client.creator
            }));
          } catch (companyError) {
            console.warn("Could not fetch company names:", companyError);
            // Continue with original data if company fetch fails
          }
        }
      }
      
      console.log("Fetched clients:", transformedData);
      return transformedData as Client[];
    },
  });
};
